import CommonComponents from '@/components/templates/common'
import { useTemplateContext } from '@/context/TemplateProvider'
import ArrowIcon from '@/assets/templates/icons/arrowIcon'
import DialIcon from '@/assets/templates/icons/dialIcon'

import Layout from './handyman.views'

const HandymanHero = () => {
  const { template } = useTemplateContext()

  return (
    <Layout className='select-none pointer-events-none'>
      <Layout.Hero
        backgroundImage={template.sections.hero.backgroundImage}
        afterBackgroundColor='#00000090'
      >
        <Layout.HeroContainer>
          <Layout.Header
            bottomBorderColor='primary'
            textColor='textSecondary'
            backgroundColor="complementary"
            backgroundOpacity={0.4}
          >
            <CommonComponents.Wrapper>
              <Layout.Logo>
                {template.logo.src ? (
                  <Layout.LogoImage src={template.logo.src} />
                ) : (
                  <Layout.LogoText fontFamily={template.logo.fontFamily}>
                    {template.logo.text}
                  </Layout.LogoText>
                )}
              </Layout.Logo>
              <Layout.Navigation textColor="textSecondary">
                {template.sections.navigation.links?.map((link, index) => <Layout.Link key={index}>{link}</Layout.Link>)}
                <Layout.Button type="primary" textColor="textPrimary" fill="complementary">
                  <DialIcon /> {template.sections.navigation.ctaText}
                </Layout.Button>
              </Layout.Navigation>
            </CommonComponents.Wrapper>
          </Layout.Header>
          <CommonComponents.Wrapper>
            <Layout.TitleContainer>
              <Layout.Title>{template.sections.hero.title}</Layout.Title>
              <Layout.Subtitle variant='subtitle1'>
                {template.sections.hero.subtitle}
              </Layout.Subtitle>
              <Layout.CTA type="primary" textColor="textPrimary" fill="complementary">
                {template.sections.hero.ctaText}
                <ArrowIcon />
              </Layout.CTA>
            </Layout.TitleContainer>
          </CommonComponents.Wrapper>
        </Layout.HeroContainer>
      </Layout.Hero>
    </Layout>
  )
}

export default HandymanHero
